import React, { useContext } from 'react';
import { Image, Carousel, Col, Row } from '@thd-olt-component-react/core-ui';
import { PackagesMiniContext } from '../PackagesMiniContext';
import { getPackageUrl } from '../../utils';
import './visual-product-images.scss';

const VisualProductImages = () => {
  const { products, packageModel } = useContext(PackagesMiniContext);
  const packageUrl = getPackageUrl(packageModel);
  const getImageUrl = (url) => url.replace(/1000(?=(.(jpg|webp)))/, '600');
  const slidesPerViewAndGroup = { slidesPerView: 2, slidesPerGroup: 2 };

  return (
    <Row data-testid="visual-product-images">
      <Col className="product-images__wrapper">
        <Carousel
          breakpoints={{
            sm: slidesPerViewAndGroup,
            md: slidesPerViewAndGroup,
            lg: slidesPerViewAndGroup,
            xl: slidesPerViewAndGroup
          }}
          slidesPerGroup={1}
          slidesPerView={1}
        >
          {products.map((product) => (
            <div
              data-testid="visual-product-image"
              className="product-images__image-item"
              key={`image-${product.itemId}`}
            >
              <a href={packageUrl}>
                <Image
                  src={getImageUrl(product?.media?.image?.url || '')}
                  alt="package product image"
                  stretchy
                  lazy
                />
              </a>
            </div>
          ))}
        </Carousel>
      </Col>
    </Row>
  );
};

VisualProductImages.displayName = 'VisualProductImages';

export { VisualProductImages };